'use client';

import { Button } from '@common/components';
import { SvgPencil } from '@common/icon';

import { useLoginGuard } from '@/hooks/useLoginGuard';
import { openResponsiveDialog } from '@/stores/DrawerStore';

import { FestivalReviewWriteForm } from './FestivalReviewWriteForm';

interface FestivalReviewWriteButtonProps {
  tourId: string;
}

export const FestivalReviewWriteButton = ({
  tourId,
}: FestivalReviewWriteButtonProps) => {
  const loginGuard = useLoginGuard();

  return (
    <Button
      theme="secondary-line"
      dimensions="H40"
      onClick={() => {
        if (!loginGuard()) return;

        openResponsiveDialog({
          component: FestivalReviewWriteForm,
          modalHeader: '후기 작성하기',
          title: '후기 작성하기',
          drawerType: 'full',
          props: { tourId },
        });
      }}
    >
      <SvgPencil className="size-14" />
      후기 남기기
    </Button>
  );
};
